const promotions = [{
    path: '/promotions',
    name: 'Promotions',
    meta: {
        auth: true,
    },
    component: () =>
        import(/* webpackChunkName: "Promotions" */ '@/views/promotions/Promotions'),
    children: [
        {
            path: 'list',
            name: 'promotions-list',
            meta: {
                auth: true,
            },
            component: () =>
                import(/* webpackChunkName: "Promotions List" */ '@/views/promotions/List'),
        },
    ],
}]

export { promotions }
